define('services/mysetting/add.contactor.service',['app', 'angular', 'mainCons'], function (app, angular, mainCons) {
	app.factory('openAddContactor', ['$filter','$location','ngDialog', 'OpenUp', 'auiDialog', 'formValidateService','$anchorScroll', function ($filter,$location,ngDialog, OpenUp, auiDialog, formValidateService,$anchorScroll) {

		/**
		 * common function
		 * @param template urls for template
		 * @return {Function}
		 */

		function common(template) {
			return function (args) {
				var handler = ngDialog.open({
					template: template,
					className: '',
					closeByEscape: false,
					closeByDocument: false,
					overlay: false,
					controller: ['$scope', '$timeout', function ($scope, $timeout) {
						var Model = $scope.Model = {};
						Model.isShowTip = false;
						Model.userID = args.userID;
						Model.contactor = {};
						init();

						var oldContactor = {};

						function init() {
							// init时，设置isShowAddConcactor为false，不显示新增表单
							Model.isShowAddConcactor = false;
							// init 时 设置isShowAddConcactorBtn为true，显示新增按钮
							Model.isShowAddConcactorBtn = true;
							OpenUp.getContactMetaList({req:{}}).then(
								function (data) {
									if (data) {
										if (data.contactList) {
											Model.contactInfos = data.contactList;
											Model.noData = false;
											if (Model.contactInfos.length >= 10) {
												Model.isShowAddConcactorBtn = false;
											}
										} else {
											Model.noData = true;
											Model.contactInfos = [];
										}
									}
								}
							);

						}

						Model.close = args.close ? function () {
								args.close();
								handler.close()
							} : handler.close;

						Model.delContact = function (row) {
							auiDialog.confirm('确认删除该联系人？', function () {
								OpenUp.deleteContactMeta({ req:{contactID: row.contactID}
								}).then(function (data) {
									if (data) {
										init();
									}
								});
							});
						};

						// 定义一变量，保存初始化时的 Model.contactor
						var oldAddContactor = {};

						Model.modContact = function (row) {
							for (var i in row) {
								Model.contactor[i] = row[i];
							}
							// 设置按钮是否 disabled
							Model.addContactorSubmbIsGray = true;
							oldAddContactor = angular.copy(Model.contactor);
							// 设置isShowAddConcactor为true，显示新增表单
							Model.isShowAddConcactor = true;

						};

						Model.showAddDiv = function () {
							Model.contactor.contactID = '';
							Model.contactor.familyName = '';
							Model.contactor.givenName = '';
							Model.contactor.title = '';
							Model.contactor.email = '';
							Model.contactor.phone = '';
							Model.contactor.fax = '';
							$scope.managerContactForm.$setDirty(false);
							$scope.managerContactForm.$setPristine(true);
							// 设置isShowAddConcactor为true，显示新增表单
							Model.isShowAddConcactor = true;
							// 设置按钮是否 disabled
							Model.addContactorSubmbIsGray = true;
							oldAddContactor = angular.copy(Model.contactor);
                            setTimeout(function () {
                                $location.hash("bottom");
                                $anchorScroll();
                            }, 20)

						};

						$scope.$watch("Model.contactor", function (newValue, oldValue) {

							if(newValue.$$hashKey){
								delete newValue.$$hashKey;
							}
							if (JSON.stringify(newValue) === JSON.stringify(oldAddContactor)) {
								Model.addContactorSubmbIsGray = true;
							} else {
								Model.addContactorSubmbIsGray = false;
							}
						}, true);

						Model.doSubmit = function (isValid) {
							if(Model.addContactorSubmbIsGray){
								return ;
							}
							if (!isValid) {
								formValidateService.validateForm($scope.managerContactForm);
							} else {
								auiDialog.confirm('确认保存吗？', function () {
									var param = {};
									var contact = {};
									if (Model.contactor.contactID) {
										contact.contactID = Model.contactor.contactID;
									}
									contact.familyName = Model.contactor.familyName;
									contact.givenName = Model.contactor.givenName;
									contact.title = Model.contactor.title;
									contact.email = Model.contactor.email;
									contact.phone = Model.contactor.phone;
									contact.fax = Model.contactor.fax ? Model.contactor.fax : '';
									contact.userID = Model.userID;
									param.contact = contact;
									if (Model.contactor.contactID) {
										OpenUp.updateContactMeta({req:param}).then(function (data) {
											init();
											Model.modContact(contact);
										});
									} else {
										OpenUp.addContactMeta({req:param}).then(function (data) {
											init();
										});
									}
								});
							}

						};

					}]
				})
			};
		}

		return {
			openPage: common('pages/mysetting/add.contactor.html')
		};

	}]);
});

